module.exports = __webpack_public_path__ + "img/eyes-closed.02ecb4df.svg";